import { tokenService } from 'utils/services';
// import actions from '_entities/Auth';

// DRF's error codes for "the session is not valid": no credentials, or credentials that no longer
// authenticate. Anything else — above all `permission_denied` — is a per-request refusal and must
// leave the session alone (#P20M-1369: a user whose role lost `import_retailer` got 403 on the
// import-progress check right after login and was silently signed out).
const AUTH_ERROR_CODES = ['not_authenticated', 'authentication_failed'];

// Backend errors are JSON:API: `{ errors: [{ detail, status, code }] }`. Only `code` is stable —
// `detail` is localized per the browser's Accept-Language, so it is never matched on.
const errorCode = (response) => response?.data?.errors?.[0]?.code;

// A 401 is an authentication failure by definition. A 403 is one only when DRF says so through the
// code (it answers NotAuthenticated with 403 when the first auth class has no authenticate_header).
export const isAuthError = (response) => {
  if (!response) return false;
  if (response.status === 401) return true;
  return response.status === 403 && AUTH_ERROR_CODES.includes(errorCode(response));
};

export default function clientMiddleware(client) {
  return ({ dispatch, getState }) =>
    (next) =>
    (action) => {
      if (typeof action === 'function') {
        return action(dispatch, getState);
      }

      const { promise, types, payload, ...rest } = action;
      if (!promise) {
        return next(action);
      }

      const [REQUEST, SUCCESS, FAILURE] = types;
      next({ ...rest, ...(payload && { payload }), type: REQUEST });

      const actionPromise = promise(client, getState);
      actionPromise
        .then(
          (result) => {
            next({
              ...rest,
              result,
              type: SUCCESS,
              staticData: getState().staticData,
              ...(payload && { payload }),
            });
          },
          (error) => {
            // Sign out on a lost session only; a permission refusal is the page's business.
            if (isAuthError(error.response)) {
              tokenService.removeToken();
            }
            next({
              ...rest,
              error,
              type: FAILURE,
              ...(payload && { payload }),
            });
          },
        )
        .catch((error) => {
          // eslint-disable-next-line
          console.error('MIDDLEWARE ERROR:', error);
          next({ ...rest, error, type: FAILURE });
        });

      return actionPromise;
    };
}
